module.exports = __webpack_public_path__ + "static/media/phone_call.350d69fb.svg";